// extracted by mini-css-extract-plugin
export default {"message":"_3zgnR0HKkRkvQjWqZoZ7Qw"};